module.exports = __webpack_public_path__ + "static/media/article1.d1ac61f5.webp";